module.exports = __webpack_public_path__ + "media/images/icon__unlocked@2x-b5cc7df81b707df61977c5e650d81088.png";